/* Copyright (c) 2022 MOCA Systems, Inc.	All rights reserved. */

import { ReportType } from './ReportType';
import * as strings from '@touchplan/strings';
import { PpcFormat } from './PpcFormat';

export interface IReportTypeMapValue {
	sortingOrdinal: number;
	type: ReportType;
}

export const reportTypeMap = new Map<string, IReportTypeMapValue>([
	[strings.REPORT_TYPE_LABEL_GANTT_CHART, { sortingOrdinal: 5, type: ReportType.GanttChart }],
	[strings.REPORT_TYPE_LABEL_WEEKLY_WORK_PLAN, { sortingOrdinal: 10, type: ReportType.WeeklyWorkPlan }],
	[strings.REPORT_TYPE_LABEL_PPC_REPORT, { sortingOrdinal: 15, type: ReportType.PPCReport }],
	[strings.REPORT_TYPE_LABEL_SIX_WEEK_LOOK_AHEAD, { sortingOrdinal: 20, type: ReportType.SixWeekLookAhead }],
	[strings.REPORT_TYPE_LABEL_CONSTRAINT_LOG, { sortingOrdinal: 25, type: ReportType.ConstraintLog }],
	[
		strings.REPORT_TYPE_LABEL_BASIC_VARIANCE_REASON,
		{ sortingOrdinal: 30, type: ReportType.BasicVarianceReason },
	],
	[
		strings.REPORT_TYPE_LABEL_ADVANCED_VARIANCE_REASON,
		{ sortingOrdinal: 32, type: ReportType.AdvancedVarianceReason },
	],
	[strings.REPORT_TYPE_LABEL_OVERDUE_ACTIVITY, { sortingOrdinal: 35, type: ReportType.OverdueActivity }],
	[strings.REPORT_TYPE_LABEL_DRAFT_TICKETS, { sortingOrdinal: 40, type: ReportType.DraftTickets }],
	[strings.REPORT_TYPE_LABEL_EXPORT_TO_CSV, { sortingOrdinal: 45, type: ReportType.ExportToCSV }],
	[strings.REPORT_TYPE_LABEL_EXPORT_TICKETS, { sortingOrdinal: 50, type: ReportType.ExportTickets }],
]);

export const DefaultReportNames = {
	[ReportType.SixWeekLookAhead]: strings.REPORT_TYPE_LABEL_SIX_WEEK_LOOK_AHEAD,
	[ReportType.WeeklyWorkPlan]: strings.REPORT_TYPE_LABEL_WEEKLY_WORK_PLAN,
	[ReportType.GanttChart]: strings.REPORT_TYPE_LABEL_GANTT_CHART,
	[ReportType.ConstraintLog]: strings.REPORT_TYPE_LABEL_CONSTRAINT_LOG,
	[ReportType.OverdueActivity]: strings.REPORT_TYPE_LABEL_OVERDUE_ACTIVITY,
	[ReportType.DraftTickets]: strings.REPORT_TYPE_LABEL_DRAFT_TICKETS,
	[PpcFormat.VarianceByRole]: strings.REPORT_PPC_FORMAT_VARIANCE_BY_ROLE,
	[PpcFormat.VarianceByWeek]: strings.REPORT_PPC_FORMAT_VARIANCE_BY_WEEK,
	[PpcFormat.PpcByRole]: strings.REPORT_PPC_FORMAT_PPC_BY_ROLE,
	[PpcFormat.PpcByWeek]: strings.REPORT_PPC_FORMAT_PPC_BY_WEEK,
	[PpcFormat.PpcByVarianceReason]: strings.REPORT_PPC_FORMAT_PPC_BY_VARIANCE,
};
